import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator,
} from "@/components/ui/command";
import { api } from "@/lib/api";
import {
  LayoutDashboard, Ticket, Plus, Bell, Shield, User, Users, LogOut, Sun,
} from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function CommandPalette({ open, onOpenChange }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    if (!open) return;
    const scope = user?.role === "agent" || user?.role === "admin" ? "all" : "mine";
    api.get(`/tickets?scope=${scope}&limit=8`).then((r) => setTickets(r.data)).catch(() => {});
  }, [open, user]);

  const go = (path) => { onOpenChange(false); navigate(path); };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Type a command or search…" data-testid="cmd-input" />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => go("/tickets/new")}><Plus className="h-4 w-4 mr-2" /> Create new ticket</CommandItem>
          <CommandItem onSelect={() => go("/tickets")}><Ticket className="h-4 w-4 mr-2" /> My tickets</CommandItem>
          <CommandItem onSelect={() => go("/dashboard")}><LayoutDashboard className="h-4 w-4 mr-2" /> Dashboard</CommandItem>
          <CommandItem onSelect={() => go("/notifications")}><Bell className="h-4 w-4 mr-2" /> Notifications</CommandItem>
          <CommandItem onSelect={() => go("/profile")}><User className="h-4 w-4 mr-2" /> Profile</CommandItem>
          {(user?.role === "agent" || user?.role === "admin") && (
            <CommandItem onSelect={() => go("/queue")}><Users className="h-4 w-4 mr-2" /> Staff queue</CommandItem>
          )}
          {user?.role === "admin" && (
            <CommandItem onSelect={() => go("/admin")}><Shield className="h-4 w-4 mr-2" /> Admin panel</CommandItem>
          )}
          <CommandItem onSelect={async () => { await logout(); onOpenChange(false); navigate("/"); }}>
            <LogOut className="h-4 w-4 mr-2" /> Sign out
          </CommandItem>
        </CommandGroup>
        {tickets.length > 0 && (
          <>
            <CommandSeparator />
            <CommandGroup heading="Recent tickets">
              {tickets.map((t) => (
                <CommandItem key={t.ticket_id} onSelect={() => go(`/tickets/${t.ticket_id}`)}>
                  <span className="font-mono text-[10px] tracking-widest uppercase text-muted-foreground mr-3">{t.ticket_number}</span>
                  <span className="truncate">{t.subject}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </>
        )}
      </CommandList>
    </CommandDialog>
  );
}
